export const START_RECORDING = 'START_RECORDING'
export const START_RECORDING_CURRENT_TAB = 'START_RECORDING_CURRENT_TAB'
export const STOP_RECORDING = 'STOP_RECORDING'
export const SET_RECORDING_VIDEO = 'SET_RECORDING_VIDEO'
export const REMOVE_VIDEO = 'REMOVE_VIDEO'
export const CLEAR_VIDEOS = 'CLEAR_VIDEOS'